import { makeStyles } from '@material-ui/core/styles';


export default makeStyles(theme => ({
    text: {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '16px',
        lineHeight: window.isMobileView ? '30px': '16px',
        color: '#3C4549',
        padding: '12px 0',
        "& span" :{
            fontWeight:'600'
        }
    },
    title: {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '15px',
        lineHeight: '24px',
        color: '#3C4549',
        padding: '10px 0'
    },
    labelHeading: {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '16px',
        color: '#3C4549',
        padding: '6px 0',
        fontWeight:'600'
    },
    label: {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '16px',
        color: '#3C4549',
        padding: '6px 0'
    },
    dialogSubHeader: {
        background: '#E3E3E3',
        width: '100%',
        "& h3": {
            margin: 0,
            padding: '11px 20px',
            fontWeight: 'bold',
            fontSize: '19px',
        }
    },
    containerBox:{
        border: '2px solid',
        padding: '0 15px',
        background: '#f3f3f3',
        width: window.isMobileView ? '100%': '',
        margin: window.isMobileView ? '5px': '',
   },
    leftPadding:{
        paddingLeft: window.isMobileView ? '10px': '60px',
    }
}))
